import CustomDropdownInput from "components/CustomDropdownInput";
import CustomTextInput from "components/CustomTextInput";
import React from "react";
import { Row, Col } from "reactstrap";
import t from "utils/Lang";

type ContractTaxProps = {
  errorData: any;
  isViewContract: boolean;
  fieldIsInvalid: (err: any) => boolean;
  taxTypes?: Array<any>;
  taxData: any;
  updateTaxData: (attribute: string, value: any) => void;
};

const ContractTax = ({
  errorData,
  isViewContract,
  fieldIsInvalid,
  taxTypes,
  taxData,
  updateTaxData,
}: ContractTaxProps) => {
  return (
    <>
      <h4 className="site-summary__label-title">{t().contract_tax}</h4>
      <Row>
        <Col sm={{ size: 6, offset: 0 }}>
          <CustomDropdownInput
            callback={updateTaxData}
            data={taxData}
            options={
              taxTypes?.map?.((type) => ({
                label: type.name,
                value: type.id,
              })) || []
            }
            labelText={`${t().site_tax__type} *`}
            attributeName="contract_tax_type_id"
            invalid={fieldIsInvalid(errorData?.contract_tax_type_id)}
            formFeedbackText={errorData?.contract_tax_type_id}
            disabled={isViewContract}
          />
        </Col>
        <Col sm={{ size: 6, offset: 0 }}>
          <CustomTextInput
            callback={updateTaxData}
            data={taxData}
            labelText={`${t().contract_tax} * (%)`}
            attributeName="tax_percentage"
            isNumeric
            isDecimal
            invalid={fieldIsInvalid(errorData?.tax_percentage)}
            formFeedbackText={errorData?.tax_percentage}
            disabled={isViewContract}
          />
        </Col>
      </Row>
    </>
  );
};

export default ContractTax;
